<div class="topdiv" >

      <div class="agGridOuterDiv">
        <div >
        <div>
            <mat-toolbar class="agGridtoperDiv card" style="
                    background: rgb(228 227 230 / 41%);border-top: 1px solid #a9a9a9a8;
            border-right: 1px solid #a9a9a9a8;
            border-left: 1px solid #a9a9a9a8;">
    
                        <label i18n="@@spmsUserReg" class="textColour">Attributes List</label>
                        
                        <span class="example-spacer"></span>
                        <!-- <button class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" [style.background-color]="buttonColor" title="Configure Pivot" (click) = "openPivotConfigurationPopup()">Configure Visuals
                        </button> -->
                          <button class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" [style.background-color]="buttonColor" title="Download Template" (click) = "downloadTemplate()">Template
                          <em style="padding: 0px 0px 0px 10px;" class="fas fa-download example-icon" title="Download"></em>
                  </button>
                        <input type="file" #fileInput  style="display: none;" (change)="onFileChange($event)">
                        <!-- Upload File Button -->
                        <button class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
                                          [style.background-color]="buttonColor"
                                          title="Upload File"
                                          (click)="fileInput.click()">
                                    Upload File
                        <em style="padding: 0px 0px 0px 10px;" class="fas fa-upload" title="Upload File"></em>
                        </button>
                       
                        
                        <button class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" [style.background-color]="buttonColor" title="Download" (click) = "onBtExport()">Download
                          <em style="padding: 0px 0px 0px 10px;" class="fas fa-download example-icon" title="Download"></em>
                  </button>
                    <div class="insertPageNoDiv">
                        <mat-form-field appearance="outline">
                            <mat-label i18n="@@spmsUserRegpageno">Page No</mat-label>
                            <input matInput type="text" (input)="onSearchChange($event.target.value)">
                        </mat-form-field>
                    </div>
    
                    <div class="selectRecordsDiv" style="width:9.5%">
                        <mat-form-field appearance="outline" style="width:100%">
                            <mat-label i18n="@@spmsUserRegrecords" style="color:black">Records</mat-label>
                            <mat-select [(ngModel)]="pagesize" (ngModelChange)="onPageSizeChanged()">
                                <mat-option value="10" selected>10</mat-option>
                                <mat-option value="200">200</mat-option>
                                <mat-option value="300">300</mat-option>
                                <mat-option value="400">400</mat-option>
                            </mat-select>
    
                        </mat-form-field>
                    </div>
                    <div class="card pagination paginationFirstButton paginationFirstlastButton">
                        <em class="fas fa-angle-double-left waves-effect waves-light" (click)="onBtFirst()"></em>
                    </div>
                    <div class="card pagination paginationButtons btn-rounded">
                        <ul>
                            <li class="paginationliicon"><em class="fas fa-angle-left waves-effect waves-light"
                                    (click)="onBtPrevious()"></em></li>
                            <li>{{currentpage}}/{{totalpages}}</li>
                            <li class="paginationliicon" style="padding:0;"><em
                                    class="fas fa-angle-right waves-effect waves-light" (click)="onBtNext()"></em></li>
                        </ul>
                    </div>
                    <div class="card pagination paginationLastButton paginationFirstlastButton">
                        <em class="fas fa-angle-double-right waves-effect waves-light" (click)="onBtLast()"></em>
                    </div>
                  </mat-toolbar>
                </div>
        <ag-grid-angular class="ag-theme-balham table-width tablestyles square scroolbar-dusty-grass square thin"
      [columnDefs]="columnDefs"  [animateRows]="true"
      [pagination]="true" [defaultColDef]="defaultColDef" [suppressPaginationPanel]="true" [rowHeight]="35"
      [headerHeight]="35" [enableBrowserTooltips]="true" [floatingFiltersHeight]="45"
      [paginationPageSize]="paginationPageSize" [paginationNumberFormatter]="paginationNumberFormatter"
      [enableRangeSelection]="true" [debug]="true" [rowClassRules]="rowClassRules"
      (paginationChanged)="onPaginationChanged()" [components]="components"
      (gridReady)="onGridReady($event)" [hidden]="!true" style="height: 30vh;margin-bottom: 3%;">
  </ag-grid-angular>
</div>
  <div class="row topRowMargins headerStyle" style="margin-top: 0;">
    <div  style="margin-left: 15px;">
      <label class="textColour" *ngIf="!onEditButton">Add Attribute</label>
      <label class="textColour" *ngIf="onEditButton">Edit Attribute</label>
    </div>
  </div> 
      <form novalidate [formGroup]='validations_form'> 
        <div class="row">
            
            <div class="col-lg-3" style="text-align: end">
                <mat-form-field appearance="outline">
                <mat-label i18n="@@TMSTAFFMASTERfirstname">Name</mat-label>
                <input matInput type="text" placeholder="Name" formControlName="attributeName"
                    [(ngModel)]="attributeObject.name" maxlength="100" required>
                <mat-error *ngFor="let validation of validation_messages.attributeName">
                    <span
                    *ngIf="validations_form.get('attributeName').hasError(validation.type) && (validations_form.get('attributeName').dirty || validations_form.get('attributeName').touched)">
                    {{ validation.message }}
                    </span>
                </mat-error>
                </mat-form-field>
            </div> 
            <div class="col-lg-3" style="text-align: end">
                <mat-form-field appearance="outline">
                <mat-label i18n="@@TMSTAFFMASTERfirstname">Label</mat-label>
                <input matInput type="text" placeholder="Label" formControlName="attributeLabel"
                    [(ngModel)]="attributeObject.label" maxlength="100" required>
                <mat-error *ngFor="let validation of validation_messages.attributeLabel">
                    <span
                    *ngIf="validations_form.get('attributeLabel').hasError(validation.type) && (validations_form.get('attributeLabel').dirty || validations_form.get('attributeLabel').touched)">
                    {{ validation.message }}
                    </span>
                </mat-error>
                </mat-form-field>
            </div> 
            <div class="col-lg-3" style="text-align: end">
              <mat-form-field class="filter" appearance="outline">
                <mat-label i18n="@@targetloginusername">
                    Type
                </mat-label>
                <mat-select placeholder="Type" formControlName="attributeType"
                [(ngModel)]="attributeObject.type">
                <mat-option  value=null>
                 None
              </mat-option>
                        <mat-option *ngFor="let tempObject of attributeTypeData" [value]="tempObject">
                            {{tempObject}}
                        </mat-option>

                </mat-select>
                <!-- <mat-error *ngFor="let validation of validation_messages.selectVisualType">
                  <span
                    *ngIf="validations_form.get('selectVisualType').hasError(validation.type) && (validations_form.get('selectVisualType').dirty || validations_form.get('selectVisualType').touched)">
                    {{ validation.message }}
                  </span>
                </mat-error> -->
            </mat-form-field>
            </div> 
            <div class="col-lg-3" style="text-align: end">
                <mat-form-field appearance="outline">
                <mat-label i18n="@@TMSTAFFMASTERfirstname">Type Value</mat-label>
                <input matInput type="text" placeholder="Type Value" formControlName="attributetype_value"
                    [(ngModel)]="attributeObject.type_value" maxlength="100">
                <!-- <mat-error *ngFor="let validation of validation_messages.filtername">
                    <span
                    *ngIf="validations_form.get('filtername').hasError(validation.type) && (validations_form.get('filtername').dirty || validations_form.get('filtername').touched)">
                    {{ validation.message }}
                    </span>
                </mat-error> -->
                </mat-form-field>
            </div> 
            <div class="col-lg-3" style="text-align: end">
                <mat-form-field appearance="outline">
                <mat-label i18n="@@TMSTAFFMASTERfirstname">Max Type Value</mat-label>
                <input matInput type="text" placeholder="Max Type Value" formControlName="attributeMax_type_value"
                    [(ngModel)]="attributeObject.max_type_value" maxlength="100">
                <!-- <mat-error *ngFor="let validation of validation_messages.filtername">
                    <span
                    *ngIf="validations_form.get('filtername').hasError(validation.type) && (validations_form.get('filtername').dirty || validations_form.get('filtername').touched)">
                    {{ validation.message }}
                    </span>
                </mat-error> -->
                </mat-form-field>
            </div> 
            <div class="col-lg-3" style="text-align: end">
                <mat-form-field appearance="outline">
                <mat-label i18n="@@TMSTAFFMASTERfirstname">Min Type Value</mat-label>
                <input matInput type="text" placeholder="Min Type Value" formControlName="attributeMin_type_value"
                    [(ngModel)]="attributeObject.min_type_value" maxlength="100">
                <!-- <mat-error *ngFor="let validation of validation_messages.filtername">
                    <span
                    *ngIf="validations_form.get('filtername').hasError(validation.type) && (validations_form.get('filtername').dirty || validations_form.get('filtername').touched)">
                    {{ validation.message }}
                    </span>
                </mat-error> -->
                </mat-form-field>
            </div> 
            <div class="col-lg-3" >
                <mat-checkbox class="example-margin"
                [(ngModel)]="attributeObject.required"
                formControlName="isAttributeRequired"
                >Required</mat-checkbox>
                <!-- <mat-error *ngFor="let validation of validation_messages.filtername">
                  <span
                    *ngIf="validations_form.get('filtername').hasError(validation.type) && (validations_form.get('filtername').dirty || validations_form.get('filtername').touched)">
                    {{ validation.message }}
                  </span>
                </mat-error> -->
            </div> 
            <div class="col-lg-3" >
                <mat-checkbox class="example-margin"
                [(ngModel)]="attributeObject.list_column"
                formControlName="attributeListColumn"
                >List Column</mat-checkbox>
                <!-- <mat-error *ngFor="let validation of validation_messages.filtername">
                  <span
                    *ngIf="validations_form.get('filtername').hasError(validation.type) && (validations_form.get('filtername').dirty || validations_form.get('filtername').touched)">
                    {{ validation.message }}
                  </span>
                </mat-error> -->
            </div> 
            <div class="col-lg-3" >
                <mat-checkbox class="example-margin"
                [(ngModel)]="attributeObject.isControlledVocabulary"
                formControlName="isControlledVocabulary"
                >Is Controlled Vocabulary</mat-checkbox>
                <!-- <mat-error *ngFor="let validation of validation_messages.filtername">
                  <span
                    *ngIf="validations_form.get('filtername').hasError(validation.type) && (validations_form.get('filtername').dirty || validations_form.get('filtername').touched)">
                    {{ validation.message }}
                  </span>
                </mat-error> -->
            </div> 
            <div *ngIf="!onEditButton" class="col-lg-3" >
                <div style="width: 15%;">
                  <label (click)="addWhere()" style="margin-top: 6px;
                    background: green;
                    margin-bottom: auto;
                    padding: 2px 5px 0px 5px;
                    border-radius: 15px;"><em class="fas fa-plus" style="color:
                      antiquewhite;font-size: large;" title="Add Attributes"></em></label>
                </div>
                </div>
                <div *ngIf="onEditButton" class="col-lg-3" >
                  <button i18n="@@TMRunButton" type="button" (click)="addWhere()" [style.background-color]="buttonColor"
                  class="actionButton btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
                  style="padding: .3rem 0.5rem;font-size: .85rem;width:40%;">Update</button>
                  </div>
        </div>
        </form>
    <div class="col-lg">
        <div class="container" style="text-align: center; margin-left: 25px;">
          <div class="row topRowMargins">
            <div class="col-lg-3"></div>
            <div class="col-lg-5">
            </div>
            <div class="col-lg-2">
              <button i18n="@@TMRunButton" type="button" (click)="saveAttributes()" [style.background-color]="buttonColor"
                class="actionButton btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
                style="padding: .3rem 1.5rem;font-size: .85rem;width:100%;">Save</button>
            </div>
            <div class="col-lg-2">
              <button i18n="@@TMRunButton" type="button" (click)="cancel()" [style.border-color]="buttonColor"
                class="cancelButton btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
                style="padding: .3rem 1.6rem;font-size: .85rem;width:100%;">Cancel</button>
            </div>
    
          </div>
        </div>
      </div>
    </div>
    </div>